// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LsQY","rootMobile":"styles_rootMobile__hEZwP"};